module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.8cac70e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-icons/font/weathericons-regular-webfont.woff
// module id = z0TB
// module chunks = 1